import moment, { Duration } from "moment";

export interface IDuration {
    text: string;
    duration: Duration;
    slug: string;
}

export class DurationSelector {
    public static readonly DataSource: IDuration[] = [
        { text: "7 days", duration: moment.duration(7, "days"), slug: "7d" },
        { text: "2 weeks", duration: moment.duration(2, "weeks"), slug: "2w" },
        { text: "1 month", duration: moment.duration(1, "month"), slug: "1m" },
        { text: "3 months", duration: moment.duration(3, "months"), slug: "3m" },
        { text: "6 months", duration: moment.duration(6, "months"), slug: "6m" },
        { text: "1 year", duration: moment.duration(1, "year"), slug: "1y" },
        { text: "2 years", duration: moment.duration(2, "years"), slug: "2y" },
        { text: "3 years", duration: moment.duration(3, "years"), slug: "3y" },
    ];

    public static getTimeInPast({ duration }: IDuration) {
        return moment().startOf("day").subtract(duration).toDate();
    }

    public static getTimeInFuture({ duration }: IDuration) {
        return moment().startOf("day").add(duration).toDate();
    }
}
